import { Loader } from 'component/customComponents/loader/loader';
import React, { ReactElement, Suspense, lazy, memo } from 'react';

const LazyStudentCourse = lazy(() =>
  import('./StudentCourse')
    .then((module) => ({ default: module.StudentCourse }))
    .catch(() => {
      document.location.reload();
      return { default: memo(() => <></>) };
    })
);

export const StudentCourse = (): ReactElement => (
  <Suspense fallback={<Loader />}>
    <LazyStudentCourse />
  </Suspense>
);
